/* HEAVELYN — bundle.js (quantity bundle offer, photo swatches) */
(function () {
  'use strict';

  var bundle = document.querySelector('[data-qbundle]');
  if (!bundle) return;

  var productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;
  var product = JSON.parse(productJson.textContent);

  var colorImages = {};
  var colorImagesEl = document.querySelector('[data-color-images]');
  if (colorImagesEl) {
    try { colorImages = JSON.parse(colorImagesEl.textContent); } catch (e) {}
  }
  var colorIndex = parseInt(bundle.getAttribute('data-color-index'), 10);

  var cards = Array.prototype.slice.call(bundle.querySelectorAll('.qbundle__card'));

  function selectedCard() {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('.qbundle__radio').checked) return cards[i];
    }
    return cards[0];
  }

  function findVariant(values) {
    return product.variants.find(function (v) {
      return values.every(function (value, i) { return v.options[i] === value; });
    });
  }

  function rowValues(row) {
    var values = [];
    Array.prototype.slice.call(row.querySelectorAll('[data-option-select]')).forEach(function (sel) {
      values[parseInt(sel.getAttribute('data-option-select'), 10)] = sel.value;
    });
    Array.prototype.slice.call(row.querySelectorAll('[data-swatch-group]')).forEach(function (group) {
      var checked = group.querySelector('[aria-checked="true"]');
      if (checked) values[parseInt(group.getAttribute('data-swatch-group'), 10)] = checked.getAttribute('data-swatch-value');
    });
    return values;
  }

  /* Disable impossible/unavailable combinations per row + sync thumbnail */
  function refreshRow(row) {
    var values = rowValues(row);
    if (!values.length) return null;

    Array.prototype.slice.call(row.querySelectorAll('[data-option-select]')).forEach(function (select) {
      var index = parseInt(select.getAttribute('data-option-select'), 10);
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        var candidate = values.slice();
        candidate[index] = opt.value;
        var variant = findVariant(candidate);
        opt.disabled = !(variant && variant.available);
      });
    });

    Array.prototype.slice.call(row.querySelectorAll('[data-swatch-group] .qbundle__swatch')).forEach(function (btn) {
      var group = btn.closest('[data-swatch-group]');
      var index = parseInt(group.getAttribute('data-swatch-group'), 10);
      var candidate = values.slice();
      candidate[index] = btn.getAttribute('data-swatch-value');
      var anyAvailable = product.variants.some(function (v) {
        return v.options[index] === candidate[index] && v.available;
      });
      btn.setAttribute('data-unavailable', anyAvailable ? 'false' : 'true');
    });

    var variant = findVariant(values);
    if (!variant || !variant.available) {
      var selects = Array.prototype.slice.call(row.querySelectorAll('[data-option-select]'));
      var last = selects[selects.length - 1];
      if (last) {
        var firstOk = Array.prototype.slice.call(last.options).find(function (o) { return !o.disabled; });
        if (firstOk) {
          last.value = firstOk.value;
          values[parseInt(last.getAttribute('data-option-select'), 10)] = firstOk.value;
          variant = findVariant(values);
        }
      }
    }
    row.setAttribute('data-variant-id', variant && variant.available ? variant.id : '');

    if (colorIndex >= 0) {
      var thumb = row.querySelector('[data-unit-thumb]');
      var img = colorImages[values[colorIndex]];
      if (thumb && img) thumb.src = img;
    }
    return variant;
  }

  function refreshAll() {
    var card = selectedCard();
    cards.forEach(function (c) { c.classList.toggle('qbundle__card--selected', c === card); });
    Array.prototype.slice.call(card.querySelectorAll('[data-unit]')).forEach(refreshRow);
    updateSticky(card);
  }

  function tierTotal(card) {
    var priceEl = card.querySelector('[data-tier-price]');
    return priceEl ? priceEl.textContent.trim() : '';
  }

  function updateSticky(card) {
    var tier = card.getAttribute('data-tier');
    document.querySelectorAll('[data-sticky-variant]').forEach(function (el) {
      el.textContent = 'Pack de ' + tier + ' · ' + tierTotal(card);
    });
  }

  bundle.addEventListener('change', function (e) {
    if (e.target.classList.contains('qbundle__radio')) refreshAll();
    if (e.target.hasAttribute('data-option-select')) refreshRow(e.target.closest('[data-unit]'));
  });

  bundle.addEventListener('click', function (e) {
    var swatch = e.target.closest('.qbundle__swatch');
    if (!swatch) return;
    e.preventDefault();
    var group = swatch.closest('[data-swatch-group]');
    Array.prototype.slice.call(group.querySelectorAll('.qbundle__swatch')).forEach(function (b) {
      b.setAttribute('aria-checked', 'false');
    });
    swatch.setAttribute('aria-checked', 'true');
    refreshRow(swatch.closest('[data-unit]'));
  });

  var errorEl = bundle.querySelector('[data-bundle-error]');

  function addBundle() {
    var card = selectedCard();
    var rows = Array.prototype.slice.call(card.querySelectorAll('[data-unit]'));
    var items = [];

    if (!rows.length) {
      var v = product.variants.find(function (x) { return x.available; });
      if (v) items.push({ id: v.id, quantity: parseInt(card.getAttribute('data-tier'), 10) });
    } else {
      for (var i = 0; i < rows.length; i++) {
        var id = rows[i].getAttribute('data-variant-id');
        if (!id) {
          errorEl.textContent = 'Une des combinaisons choisies est épuisée.';
          errorEl.hidden = false;
          return;
        }
        items.push({ id: parseInt(id, 10), quantity: 1 });
      }
    }

    errorEl.hidden = true;
    var btn = bundle.querySelector('[data-bundle-atc]');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function (cartData) {
      /* Fire one bundle-level event with total qty and value, for Meta pixel tracking. */
      var totalQty = items.reduce(function (n, it) { return n + it.quantity; }, 0);
      var totalValue = 0;
      items.forEach(function (it) {
        var v = product.variants.find(function (x) { return x.id === it.id; });
        if (v) totalValue += (v.price / 100) * it.quantity;
      });
      try {
        window.dispatchEvent(new CustomEvent('heavelyn:bundle_added', {
          detail: {
            product_id: product.id,
            tier: card.getAttribute('data-tier'),
            num_items: totalQty,
            value: totalValue,
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            variant_ids: items.map(function (it) { return it.id; })
          }
        }));
      } catch (e) {}
      if (window.openCartDrawer) window.openCartDrawer();
    }).catch(function (err) {
      errorEl.textContent = (err && err.description) || 'Impossible d’ajouter au panier.';
      errorEl.hidden = false;
    }).finally(function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  }

  bundle.querySelector('[data-bundle-atc]').addEventListener('click', addBundle);

  /* Sticky bar integration (no classic product form on this template) */
  document.querySelectorAll('[data-sticky-submit]').forEach(function (btn) {
    btn.addEventListener('click', addBundle);
  });
  if (document.querySelector('.sticky-atc')) {
    document.body.classList.add('has-sticky-atc');
  }

  refreshAll();
})();
